import isDeepEqualReact from 'fast-deep-equal/react';
export default isDeepEqualReact;